import type { GoogleAuthInterface } from "./interface"
import { GoogleAuthNative } from "~/capacitor/google"
import { useTokenCookie } from "../local/token-cookie"

export function useGoogleAuthNative(): GoogleAuthInterface {
	const loading = ref(false)
	const api = useApi()
	const login = useLogin()
	const token = useTokenCookie()
	const notify = useNotification()
	const config = useRuntimeConfig()

	async function initialize() {
		await GoogleAuthNative.init({ key: config.public.google.clientId })
	}

	async function signIn() {
		loading.value = true
		const code = await selectAccount()

		if (!code) {
			loading.value = false
			return
		}

		try {
			const res = await api.user.exchangeGoogleJwt({ jwt: code })
			token.setCookie(res.data.token)
			login.setUser(res.data.me)
			await navigateTo("/app")
		}
		catch (e) {
			notify.errorObject(e as any)
		}

		loading.value = false
	}

	async function selectAccount() {
		try {
			await initialize()
			const { jwt } = await GoogleAuthNative.handleSignIn()
			return jwt
		}
		catch (e) {
			const error = e as Error
			console.error(error)
			return null
		}
	}

	return {
		initialize,
		signIn,
		loading,
	}
}
